import React, { useEffect, useState } from "react";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  admin_company_details,
  institutions_detail,
  update_academic,
} from "../../admin.api";
import { useParams } from "react-router-dom";
import moment from "moment";
import CommonForm from "../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../components/formValidate";
import TextEditer from "../../../../components/inputs/texteditor";
import TextField from "../../../../components/inputs/textfield";
let flag = false;
export default function EditAcademic(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({});
  const [keyvalue, setKeyvalue] = useState(0);
  const [domainData, setDomain] = useState([]);
  const [count, setCount] = useState(1);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [fileChanged, setFileChanged] = useState(false);

  const selectedParam = useParams();
  const getAcademicDetails = () => {
    if (!selectedParam?.id) {
      return;
    }
    institutions_detail(selectedParam.id)
      .then((res) => {
        if (res?.data) {
          const data = {
            ...res?.data,
            formFileSm: res?.data?.logo
          }
          setBasicData(data);
        }
      })
      .catch((err) =>
        console.error(
          "Error fetching Companies in KSPACE Premises details:",
          err
        )
      );
  };

  useEffect(() => {
    getAcademicDetails();
  }, [selectedParam]);

  const handlePhoneNumberChange = (e) => {
    //
    let name = e.target.name;
    let value = e.target.value;
    //
    //
    if (value.length <= 10) {
      let newValue = value.replace(/[^0-9]/g, "");
      let data = basicData;
      data = {
        ...data,

        [name]: newValue,
      };
      setBasicData(data);
    }
  };

  const handleNumberChange = (e) => {
    let data = { ...basicData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setBasicData(data);
  };
  const handleSubmit = (e) => {

    const requiredFields = {
      institution_name: "Institution Name",
      address: "Address",
      email: "Email",
      phone_no: "Phone Number",
      affiliation: "Affiliation",
      total_students: "Total Students",
      headquaters_detail: "Headquarters Detail",
      contact_person_details: "Contact Person Details",
      registration_date: "Registration Date",
      financial_year: "Financial Year",
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([key]) => !basicData[key])
      .map(([_, label]) => label);

    if (missingFields.length > 0) {
      const message = `Please fill in ${missingFields.join(", ")}`;
      setSnackMessage(message);
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const form = new FormData();

    form.append("id", basicData.id ?? null);
    form.append("institution_name", basicData.institution_name ?? null);
    form.append("address", basicData.address ?? null);
    form.append("email", basicData.email ?? null);
    form.append("phone_no", basicData.phone_no ?? null);
    form.append("alternate_email", basicData.alternate_email ?? "");

    if (typeof basicData.logo !== "string") {
      form.append("logo", basicData.logo ?? "");
    }

    form.append("affiliation", basicData.affiliation ?? "");
    form.append("total_students", basicData.total_students ?? "");
    form.append("headquaters_detail", basicData.headquaters_detail ?? "");
    form.append("contact_person_details", basicData.contact_person_details ?? "");

    if (typeof basicData.file_submitted_record !== "string") {
      form.append("file_submitted_record", basicData.file_submitted_record ?? "");
    }

    form.append("country_code", basicData.alternate_phone ? basicData.country_code : "");
    form.append("alternate_phone", basicData.alternate_phone ?? "");
    form.append("registration_date", basicData.registration_date ?? "");
    form.append("financial_year", basicData.financial_year ?? "");
    form.append("notes_institutions", basicData.notes_institutions ?? "");

    setIsActive(true);

    update_academic(selectedParam.id, form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error?.response?.data?.message || "Something went wrong.");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      setActiveStep(0);
      setBasicData({});

      setDomain([]);
      props.history.push("/academicinstitution-list");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setBasicData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const getDetails = (domData) => {
    let otherDom = [];
    admin_company_details(selectedParam.id).then((res) => {
      let Data = res?.data;
      otherDom = Data?.domain_types?.filter(
        (ar1) => !domData.some((ar2) => ar1?.domain_name === ar2?.domain_name)
      );

      domData?.forEach((item) => {
        item["checked"] = Data?.domain_types?.some(
          (dom) => item?.domain_name === dom?.domain_name
        );
      });
      setDomain(domData);
      let d = {
        ...Data,
        any_other_flag:
          Data.any_other_flag && Data.any_other_flag !== "0" ? true : false,
        any_other_domain:
          Data.any_other_domain && Data.any_other_flag !== "0"
            ? Data.any_other_domain
            : "",
        country_code:
          Data.country_code === "null" || Data.country_code === "undefined"
            ? ""
            : Data.country_code,
      };

      setCount(count + 1);
    });
    setIsActive(false);
  };

  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = basicData;
    data[name] = value;
    setBasicData(data);
    setKeyvalue(keyvalue + 1);
  };
  const addNewProductProfile = (i) => {
    let data = { ...basicData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setBasicData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...basicData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: e.target.value,
    };

    setBasicData(data);
    setCount(count + 1);
  };
  const handleProductDesc = (val, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val,
    };

    setBasicData(data);
    setCount(count + 1);
  };
  const handleCourseChange = (e, i) => {
    let data = { ...basicData };

    data.course_details[i] = {
      ...data.course_details[i],
      [e.target.name]: e.target.value,
    };

    setBasicData(data);
  };

  const addCourse = (i) => {
    let data = { ...basicData };

    data.course_details.push({
      course_name: "",
      course_type: "Technical",
    });
    setBasicData(data);
    setCount(count + 1);
  };
  const removeCourse = (i) => {
    let data = { ...basicData };
    data.course_details.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "png" ||
      type?.toLowerCase() === "jpeg" ||
      type?.toLowerCase() === "jpg" ||
      type?.toLowerCase() === "pdf"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setBasicData({
          ...basicData,
          file_name: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });

        // handlefile();
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setBasicData({
          ...basicData,
          file_name: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      setBasicData({
        ...basicData,
        file_name: null,
        [e.target.name]: null,
      });
    }
  };
  return (
    <>
      <Loader open={isActive} />
      <div className="add-per">
        <div className="view-container">
          <h6>
            <b>Update Application</b>
          </h6>
          <hr />
          <div className="row">
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Name of the Institution"
                required
                disabled
                name="institution_name"
                value={basicData.institution_name ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>

            <div className="col-8 mb-2">
              <CommonForm
                fieldType="multiline"
                label="Registered Office Address"
                required
                name="address"
                value={basicData.address ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>

            <div className="col-8 mb-2">
              <CommonForm
                fieldType="email"
                label="Email"
                error={error.email}
                disabled
                required
                name="email"
                value={basicData.email ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>

            <div className="col-8 mb-2">
              <CommonForm
                fieldType="text"
                label="Phone Number"
                maxLength="10"
                minLength="10"
                disabled
                pattern="[0-9]{10}"
                value={basicData?.phone_no ?? ""}
                required
                onChange={(e) => {
                  handlePhoneNumberChange(e);
                }}
                name="phone_no"
                {...props}
              />
            </div>
            <div className="col-8 mb-2">
              <label className="control-label mylabel mb-2">
                Alternate Phone
              </label>

              <div className="d-flex align-items-end w-100">
                <div className="">
                  <CommonForm
                    fieldType="text"
                    error={error.country_code}
                    name="country_code"
                    disabled
                    maxLength="4"
                    value={basicData?.country_code ?? ""}
                    onChange={(e) => {
                      handleNumberChange(e);
                    }}
                    {...props}
                  />
                </div>
                <div className="p-1"></div>
                <div className="col-10">
                  <CommonForm
                    fieldType="text"
                    error={error.alternate_phone}
                    name="alternate_phone"
                    maxLength="10"
                    disabled
                    value={basicData?.alternate_phone ?? ""}
                    onChange={(e) => {
                      handleNumberChange(e);
                    }}
                    {...props}
                  />
                </div>
              </div>
            </div>
            <div className="col-8 mb-2">
              <div className="mb-2 mylabel">Financial Year</div>
              <select
                className="form-select selectbox "
                aria-label="Select Financial Year"
                name="financial_year"
                required
                value={basicData.financial_year ?? ""}
                onChange={(e) => handleChange(e)}
              >
                <option value="">Select Financial Year</option>
                {financialYears.map((year) => (
                  <option
                    key={year}
                    value={year}
                    disabled={currentYear < year}
                  >
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-8">
            <TextField
              label="Logo"
              required
              id="formFileSm"
              onChange={(e) => handleFileChange(e)}
              accept=".jpg,.jpeg,.png"
              fileName={
                basicData.file_name
                  ? basicData.file_name
                  : basicData.logo
              }
              name="logo"
              type="file"
            />
            <small className="pers">
              *Upload only .jpg , .jpeg , .png format and Size should be less
              than 1MB
            </small>
          </div>
          <div className="col-8">
            <CommonForm
              fieldType="text"
              label="Affiliation Details with Affiliation Number"
              required
              disabled
              name="affiliation"
              multiline
              value={basicData.affiliation ?? ""}
              onChange={(e) => {
                // handleDatePickerChange(e, "registration_date");
                textFieldChange(e);
              }}
              {...props}
              maxDate={new Date()}
            />
          </div>

          <div className="col-8">
            <CommonForm
              fieldType="number"
              label="Total Number of Students"
              required
              disabled
              name="total_students"
              pattern="[0-9]"
              value={basicData.total_students ?? ""}
              onChange={(e) => {
                handleNumberChange(e);
              }}
              {...props}
            />
          </div>
          <div className="col-8">
            <CommonForm
              fieldType="text"
              label="Headquarters Details (limit: 20 Words) "
              required
              disabled
              maxLength={150}
              value={basicData.headquaters_detail ?? ""}
              name="headquaters_detail"
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>
          <div className="col-8">
            <CommonForm
              fieldType="text"
              label="Name and Designation of Authorized Person with contact  details"
              multiline
              required
              disabled
              name="contact_person_details"
              className="no-margin"
              value={basicData.contact_person_details ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>

          <div className="col-8">
            <TextField
              label="Upload Proof of registration"
              required
              id="file_registration_proof"
              onChange={(e) => handleFileChange(e)}
              accept=".jpg,.jpeg,.png"
              disabled
              fileName={
                basicData.file_name
                  ? basicData.file_name
                  : basicData.file_registration_proof
              }
              name="file_registration_proof"
              type="file"
            />
            <small className="pers">
              *Upload only .jpg , .jpeg , .png format and Size should be less
              than 1MB of width: 400 Height: 400
            </small>
          </div>
          <div className="header-label">Courses Offered</div>
          {basicData.courses?.map((e, i) => (
            <div className="section-datas-cont mb-3 col-8">
              <div className="section-Cont ">
                <div className="row pb-3">
                  <div className="col-xs-5 col-sm-6 mt-2">
                    <div className=" input-group">
                      {" "}
                      <label className={"control-label mylabel mb-2"}>
                        Course Type
                      </label>
                    </div>
                    <select
                      id="course_type"
                      className="mandatory-select form-select selectbox w-100"
                      required
                      label="bbbb"
                      disabled
                      name="course_type"
                      onChange={(e) => handleCourseChange(e, i)}
                      value={e?.course_type ?? ""}
                    >
                      <option value="Technical">Technical</option>
                      <option value="Non-Technical">Non-Technical</option>
                    </select>
                  </div>
                  <div className="col-xs-6 col-sm-6 mt-2">
                    <div className=" input-group">
                      {" "}
                      <label className={"control-label mylabel mb-2"}>
                        Course
                      </label>
                    </div>
                    <select
                      id="course_name"
                      className="mandatory-select form-select selectbox w-100"
                      required
                      disabled
                      label="bbbb"
                      name="course_name"
                      onChange={(e) => handleCourseChange(e, i)}
                      value={e?.course_name ?? ""}
                    >
                      {e.course_type === "Technical" ? (
                        <>
                          <option value="">Select Course</option>
                          <option value="ITI">ITI</option>
                          <option value="Diploma">Diploma</option>
                          <option value="Graduation">Graduation</option>
                          <option value="Post-Graduation">
                            Post-Graduation
                          </option>
                          <option value="MPhil">MPhil</option>
                          <option value="PhD">PhD</option>
                        </>
                      ) : e.course_type === "Non-Technical" ? (
                        <>
                          {" "}
                          <option value="">Select Course</option>
                          <option value="12th">12th</option>
                          <option value="Graduation">Graduation</option>
                          <option value="Post-Graduation">
                            Post-Graduation
                          </option>
                          <option value="MPhil">MPhil</option>
                          <option value="PhD">PhD</option>
                        </>
                      ) : (
                        <option value="">Select Course Type</option>
                      )}
                    </select>
                  </div>
                  {/* <CommonForm
                        fieldType="text"
                        label="Course Name"
                        required
                        name="course_name"
                        value={e?.course_name}
                        onChange={(e) => {
                          handleCourseChange(e, i);
                        }}
                        {...props}
                      /> */}
                </div>
              </div>

              <div className="more-btn-cnt">
                {basicData.course_details?.length === i + 1 && (
                  <button
                    style={{ marginLeft: 5 }}
                    type="button"
                    {...props}
                    className="btn btn-primary"
                    onClick={(e) => addCourse(i)}
                  >
                    Add More
                  </button>
                )}
                {basicData.course_details?.length > 1 && (
                  <button
                    {...props}
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => removeCourse(i)}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          ))}
          <div className="col-8">
            <CommonForm
              fieldType="text"
              label="Brief note on Institution activities"
              multiline
              required
              value={basicData.notes_institutions ?? ""}
              className="no-margin"
              disabled
              name="notes_institutions"
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>


          {/* ///////////////////////////////////// */}
          {/* ///actions ////////////// */}
          <div className="">
            <div className="col-8 mb-2 mt-2">
              <center>
                <button type="submit" className="primary-btn basic-submit" onClick={() => handleSubmit()}>
                  SUBMIT
                </button>
              </center>
            </div>
          </div>
          {/* </form> */}
        </div>
      </div>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </>
  );
}
